import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './parts.css'

/**
 * The main content region of a composed [Drawer](/components/drawer/). This is
 * the scrolling zone between the fixed header and footer; the drawer's `padding`
 * attribute applies here.
 *
 * It occupies the drawer's default slot, so place it as a direct child of
 * `nord-drawer` (no `slot` attribute).
 *
 * @status draft
 * @category structure
 * @lightDom true
 *
 * @slot - The drawer body content.
 */
@customElement('nord-drawer-body')
export default class DrawerBody extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style, 'nord-drawer-parts')
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-drawer-body': DrawerBody
  }
}
